<div id="countrymaster" *ngIf="divVisibilityMap['countrymaster']">
    <div class="row">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="navigateToLocationComponent()">
                <i class="bi bi-person-fill-add" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Country Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" style="display: none;">Country Master ID</th>
                        <th scope="col">Country Name</th>
                        <th scope="col">Active</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of OneFeildData ; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="display: none;">{{ site['CountryMasterID'] }}</td>
                        <td>{{ site['CountryName'] }}</td>
                        <td>{{ site['Active'] == 'Y' ? 'Yes' : 'No'}}</td>
                        <td>
                            <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                (click)="click('country', site)">
                                <i class="bi bi-pencil-square text-warning"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>

<div id="gunmaster" *ngIf="divVisibilityMap['gunmaster']">
    <div class="row">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="navigateToLocationComponent()">
                <i class="bi bi-person-fill-add" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Type Of Gun Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" style="display: none;">Type of Gun Master ID</th>
                        <th scope="col">Type of Gun Name</th>
                        <th scope="col">Active</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of OneFeildData ; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="display: none;">{{ site['TypeofGunMasterID'] }}</td>
                        <td>{{ site['TypeofGunName'] }}</td>
                        <td>{{ site['Active'] == 'Y' ? 'Yes' : 'No'}}</td>
                        <td>
                            <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                (click)="click('Gun', site)">
                                <i class="bi bi-pencil-square text-warning"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>

<div id="reasonmaster" *ngIf="divVisibilityMap['reason']">
    <div class="row">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="navigateToLocationComponent()">
                <i class="bi bi-person-fill-add" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Reason Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" style="display: none;">Reason Master ID</th>
                        <th scope="col">Reason Name</th>
                        <th scope="col">Active</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of OneFeildData ; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="display: none;">{{ site['ReasonMasterID'] }}</td>
                        <td>{{ site['ReasonName'] }}</td>
                        <td>{{ site['Active'] == 'Y' ? 'Yes' : 'No'}}</td>
                        <td>
                            <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                (click)="click('reason', site)">
                                <i class="bi bi-pencil-square text-warning"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>

<div id="colormaster" *ngIf="divVisibilityMap['color']">
    <div class="row">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="navigateToLocationComponent()">
                <i class="bi bi-person-fill-add" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Color Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" style="display: none;">Colour Master ID</th>
                        <th scope="col">Colour Name</th>
                        <th scope="col">Active</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of OneFeildData ; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="display: none;">{{ site['ColourMasterID'] }}</td>
                        <td>{{ site['ColourName'] }}</td>
                        <td>{{ site['Active'] == 'Y' ? 'Yes' : 'No'}}</td>
                        <td>
                            <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                (click)="click('color', site)">
                                <i class="bi bi-pencil-square text-warning"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>

<div id="uniformsizemaster" *ngIf="divVisibilityMap['uniform']">
    <div class="row">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="navigateToLocationComponent()">
                <i class="bi bi-person-fill-add" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Uniform Size Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" style="display: none;">Uniform Size Master ID</th>
                        <th scope="col">Uniform Size Name</th>
                        <th scope="col">Active</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of OneFeildData ; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="display: none;">{{ site['UniformSizeMasterID'] }}</td>
                        <td>{{ site['UniformSizeName'] }}</td>
                        <td>{{ site['Active'] == 'Y' ? 'Yes' : 'No'}}</td>
                        <td>
                            <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                (click)="click('uniform', site)">
                                <i class="bi bi-pencil-square text-warning"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>

<div id="shoesizemaster" *ngIf="divVisibilityMap['shoe']">
    <div class="row">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="navigateToLocationComponent()">
                <i class="bi bi-person-fill-add" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Shoes Size Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" style="display: none;">Shoes Size Master ID</th>
                        <th scope="col">Shoes Size Name</th>
                        <th scope="col">Active</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of OneFeildData ; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="display: none;">{{ site['ShoesSizeMasterID'] }}</td>
                        <td>{{ site['ShoesSizeName'] }}</td>
                        <td>{{ site['Active'] == 'Y' ? 'Yes' : 'No'}}</td>
                        <td>
                            <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                (click)="click('shoes', site)">
                                <i class="bi bi-pencil-square text-warning"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>

<div id="designationgrpmaster" *ngIf="divVisibilityMap['designationgrp']">
    <div class="row">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="navigateToLocationComponent()">
                <i class="bi bi-person-fill-add" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Designation Group Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" style="display: none;">Designation Group Master ID</th>
                        <th scope="col">Designation Group Name</th>
                        <th scope="col">Active</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of OneFeildData ; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="display: none;">{{ site['DesignationGroupMasterID'] }}</td>
                        <td>{{ site['DesignationGroupName'] }}</td>
                        <td>{{ site['Active'] == 'Y' ? 'Yes' : 'No'}}</td>
                        <td>
                            <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                (click)="click('desigrp', site)">
                                <i class="bi bi-pencil-square text-warning"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>


<div id="qualificationmaster" *ngIf="divVisibilityMap['qualification']">
    <div class="row">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="navigateToLocationComponent()">
                <i class="bi bi-person-fill-add" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Qualification Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" style="display: none;">Qualification Master ID</th>
                        <th scope="col">Qualification Name</th>
                        <th scope="col">Active</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of OneFeildData ; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="display: none;">{{ site['QualificationMasterID'] }}</td>
                        <td>{{ site['QualificationName'] }}</td>
                        <td>{{ site['Active'] == 'Y' ? 'Yes' : 'No'}}</td>
                        <td>
                            <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                (click)="click('qualification', site)">
                                <i class="bi bi-pencil-square text-warning"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>


<div id="religionmaster" *ngIf="divVisibilityMap['religion']">
    <div class="row">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="navigateToLocationComponent()">
                <i class="bi bi-person-fill-add" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Religion Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" style="display: none;">Religion Master ID</th>
                        <th scope="col">Religion Name</th>
                        <th scope="col">Active</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of OneFeildData ; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="display: none;">{{ site['ReligionMasterID'] }}</td>
                        <td>{{ site['ReligionName'] }}</td>
                        <td>{{ site['Active'] == 'Y' ? 'Yes' : 'No'}}</td>
                        <td>
                            <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                (click)="click('religion', site)">
                                <i class="bi bi-pencil-square text-warning"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>

<div id="mothertonguemaster" *ngIf="divVisibilityMap['mother']">
    <div class="row">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="navigateToLocationComponent()">
                <i class="bi bi-person-fill-add" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Mother Tongue Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" style="display: none;">Mother Tongue Master ID</th>
                        <th scope="col">Mother Tongue Name</th>
                        <th scope="col">Active</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of OneFeildData ; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="display: none;">{{ site['MotherTongueMasterID'] }}</td>
                        <td>{{ site['MotherTongueName'] }}</td>
                        <td>{{ site['Active'] == 'Y' ? 'Yes' : 'No'}}</td>
                        <td>
                            <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                (click)="click('mother', site)">
                                <i class="bi bi-pencil-square text-warning"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>

<div id="relationshipmaster" *ngIf="divVisibilityMap['relationship']">
    <div class="row">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="navigateToLocationComponent()">
                <i class="bi bi-person-fill-add" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Relationship Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" style="display: none;">Relationship Master ID</th>
                        <th scope="col">Relationship Name</th>
                        <th scope="col">Active</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of OneFeildData ; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="display: none;">{{ site['RelationshipMasterID'] }}</td>
                        <td>{{ site['RelationshipName'] }}</td>
                        <td>{{ site['Active'] == 'Y' ? 'Yes' : 'No'}}</td>
                        <td>
                            <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                (click)="click('relation', site)">
                                <i class="bi bi-pencil-square text-warning"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>

<div id="castermaster" *ngIf="divVisibilityMap['caste']">
    <div class="row">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="navigateToLocationComponent()">
                <i class="bi bi-person-fill-add" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Caste Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" style="display: none;">Caste Master ID</th>
                        <th scope="col">Caste Name</th>
                        <th scope="col">Active</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of OneFeildData ; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="display: none;">{{ site['CasteMasterID'] }}</td>
                        <td>{{ site['CasteName'] }}</td>
                        <td>{{ site['Active'] == 'Y' ? 'Yes' : 'No'}}</td>
                        <td>
                            <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                (click)="click('caste', site)">
                                <i class="bi bi-pencil-square text-warning"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>

<div id="nationalitymaster" *ngIf="divVisibilityMap['nationality']">
    <div class="row">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="navigateToLocationComponent()">
                <i class="bi bi-person-fill-add" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Nationality Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" style="display: none;">Nationality Master ID</th>
                        <th scope="col">Nationality</th>
                        <th scope="col">Active</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of OneFeildData ; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="display: none;">{{ site['NationalityMasterID'] }}</td>
                        <td>{{ site['NationalityName'] }}</td>
                        <td>{{ site['Active'] == 'Y' ? 'Yes' : 'No'}}</td>
                        <td>
                            <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                (click)="click('nationality', site)">
                                <i class="bi bi-pencil-square text-warning"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>

<div id="languagemaster" *ngIf="divVisibilityMap['language']">
    <div class="row">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="navigateToLocationComponent()">
                <i class="bi bi-person-fill-add" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Language Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" style="display: none;">Language Master ID</th>
                        <th scope="col">Language</th>
                        <th scope="col">Active</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of OneFeildData ; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="display: none;">{{ site['LanguageMasterID'] }}</td>
                        <td>{{ site['LanguageName'] }}</td>
                        <td>{{ site['Active'] == 'Y' ? 'Yes' : 'No'}}</td>
                        <td>
                            <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                (click)="click('language', site)">
                                <i class="bi bi-pencil-square text-warning"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>

<div id="designationcategorymaster" *ngIf="divVisibilityMap['designationctgry']">
    <div class="row">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="navigateToLocationComponent()">
                <i class="bi bi-person-fill-add" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Designation Category Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" style="display: none;">Designation Category Master ID</th>
                        <th scope="col">Designation Category Name</th>
                        <th scope="col">Active</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of OneFeildData ; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="display: none;">{{ site['DesignationCategoryMasterID'] }}</td>
                        <td>{{ site['DesignationCategoryName'] }}</td>
                        <td>{{ site['Active'] == 'Y' ? 'Yes' : 'No'}}</td>
                        <td>
                            <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                (click)="click('category', site)">
                                <i class="bi bi-pencil-square text-warning"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>

<div id="reporttypemaster" *ngIf="divVisibilityMap['report']">
    <div class="row">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="navigateToLocationComponent()">
                <i class="bi bi-person-fill-add" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Report type Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" style="display: none;">Report Type Master ID</th>
                        <th scope="col">Report Type</th>
                        <th scope="col">Active</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of OneFeildData ; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="display: none;">{{ site['ReportTypeMasterID'] }}</td>
                        <td>{{ site['ReportTypeName'] }}</td>
                        <td>{{ site['Active'] == 'Y' ? 'Yes' : 'No'}}</td>
                        <td>
                            <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                (click)="click('report', site)">
                                <i class="bi bi-pencil-square text-warning"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>

<div id="groupmaster" *ngIf="divVisibilityMap['group']">
    <div class="row">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="navigateToLocationComponent()">
                <i class="bi bi-person-fill-add" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Group Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" style="display: none;">Group Master ID</th>
                        <th scope="col">Group Name</th>
                        <th scope="col">Active</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of OneFeildData ; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="display: none;">{{ site['GroupMasterID'] }}</td>
                        <td>{{ site['GroupName'] }}</td>
                        <td>{{ site['Active'] == 'Y' ? 'Yes' : 'No'}}</td>
                        <td>
                            <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                (click)="click('group', site)">
                                <i class="bi bi-pencil-square text-warning"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>

<div id="dutymaster" *ngIf="divVisibilityMap['duty']">
    <div class="row">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="navigateToLocationComponent()">
                <i class="bi bi-person-fill-add" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Duty Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" style="display: none;">Duty Master ID</th>
                        <th scope="col">Duty</th>
                        <th scope="col">Active</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of OneFeildData ; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="display: none;">{{ site['DutyMasterID'] }}</td>
                        <td>{{ site['DutyName'] }}</td>
                        <td>{{ site['Active'] == 'Y' ? 'Yes' : 'No'}}</td>
                        <td>
                            <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                (click)="click('duty', site)">
                                <i class="bi bi-pencil-square text-warning"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>

<div id="rateapplicationmaster" *ngIf="divVisibilityMap['rateapplication']">
    <div class="row">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="navigateToLocationComponent()">
                <i class="bi bi-person-fill-add" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Rate Application Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" style="display: none;">Rate Applicable Master ID</th>
                        <th scope="col">Rate Applicable</th>
                        <th scope="col">Active</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of OneFeildData ; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="display: none;">{{ site['RateApplicableID'] }}</td>
                        <td>{{ site['RateApplicableName'] }}</td>
                        <td>{{ site['Active'] == 'Y' ? 'Yes' : 'No'}}</td>
                        <td>
                            <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                (click)="click('rate', site)">
                                <i class="bi bi-pencil-square text-warning"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>